import React, { Component } from 'react';
import styled from 'styled-components';

const SearchSvgStyled = styled.span`
  position: relative;
  display: inline-block;
  width: 100%;
  padding-bottom: 100%; // viewBox height / viewBox width x 100%

  svg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    box-sizing: content-box;
  }
`;

class SearchSvg extends Component {
  render() {
    return (
      <SearchSvgStyled>
        <svg
          viewBox="0 0 28 28"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-536.000000, -439.000000)" fill="#FFFFFF">
              <g transform="translate(536.000000, 439.000000)">
                <path
                  d="M27.4861893,25.1481114 L19.8201893,17.4791114 C21.1943307,15.6049187 21.9304529,13.3390645 21.9201893,11.0151114 C21.8939699,4.94882293 16.9874333,0.0351488795 10.9211893,0.000111435652 C8.01814962,-0.0130231459 5.23043207,1.13542457 3.17906127,3.18961293 C1.12769048,5.24380128 -0.0169298572,8.03309251 0.000189300439,10.9361114 C0.0264087219,17.0029522 4.93339304,21.917074 11.0001893,21.9521114 C13.3336097,21.9622247 15.6077423,21.2175103 17.4831893,19.8291114 L17.4911893,19.8231114 L25.1501893,27.4861114 C25.564287,27.9205384 26.1813209,28.0963842 26.7622191,27.9455169 C27.3431174,27.7946495 27.796604,27.3407746 27.9469741,26.7597475 C28.0973443,26.1787204 27.9209705,25.5618372 27.4861893,25.1481114 L27.4861893,25.1481114 Z M10.9921893,19.7561114 C6.13901742,19.7281935 2.2134938,15.7973168 2.1921893,10.9441114 C2.17909048,8.62199708 3.09486209,6.39101223 4.73564974,4.74778293 C6.3764374,3.10455363 8.60605803,2.18546559 10.9281893,2.19511144 C15.7813612,2.22302941 19.7068848,6.15390602 19.7281893,11.0071114 C19.7412881,13.3292258 18.8255165,15.5602106 17.1847289,17.2034399 C15.5439412,18.8466692 13.3143206,19.7657573 10.9921893,19.7561114 Z"
                  id="Search"
                />
              </g>
            </g>
          </g>
        </svg>
      </SearchSvgStyled>
    );
  }
}

export default SearchSvg;



/** WEBPACK FOOTER **
 ** ./src/components/LeadsForm/SearchSvg.js
 **/